import { TwinDictionary } from '../../../../../../../../utils/globals/dictionary'

export const createModalComplexProductMatrixStructure = (subProducts: TwinDictionary[], currentDictionary: TwinDictionary, variants: any, main: number, parentName: string): any => {
    const usedVariants = new Set<number>()
    const rows: TwinDictionary[] = []
    let last_item = null
    for (let element of subProducts) {
        const itemsForKey = []
        const combinationName = []
        let id = 0
        const variantValues = element.ProductVariantGroup?.VariantValues
        const pastValue = currentDictionary[element.id]
        if (pastValue) {
            const { quantity, initialUnitPriceWithoutTax, id, discount, typeDiscount, delivery_date, nLine } = pastValue
            element = { ...element, quantity, initialUnitPriceWithoutTax, LineId: id, discount: discount || 0, typeDiscount: typeDiscount || 0, delivery_date: delivery_date === '' ? null : delivery_date, nLine: nLine, _oldQuantity: quantity }
        }
        for (let key in variantValues) {
            const item = variantValues[key]
            const isNotMainForHaveColumnApart = item.VariantGroupId !== main
            if (isNotMainForHaveColumnApart) {
                itemsForKey.push(item.id)
                combinationName.push(variants?.variants[item.VariantGroupId].values[item.id].name)
            } else {
                id = item.id
            }
        }
        usedVariants.add(id)
        const key = itemsForKey.join('-')
        const finalCombinationName = combinationName.join(' - ') !== '' ? combinationName.join(' - ') : parentName
        if (!last_item && last_item !== key) {
            last_item = key
            rows.push({ combinationName: finalCombinationName })
        } else if (last_item !== key) {
            last_item = key
            rows.push({ combinationName: finalCombinationName })
        }
        rows[rows.length - 1][id] = { ...element }
    }
    const mustInvertIfOnlyMain = rows.length === 1 && usedVariants.size > 3
    if (mustInvertIfOnlyMain){
        return createModalComplexProductMatrixStructure(subProducts, currentDictionary, variants, 0, parentName)
    }
    return { rows, usedVariants }
}